import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <Section background="charcoal" className="text-center py-32" data-id="element-129" data-mp="3uei1xeuj5o1t">
      <div className="max-w-3xl mx-auto" data-id="element-130" data-mp="c7k5ny2p8nov">
        <FadeIn data-id="element-131" data-mp="c4fv8iyn4vpr">
          <h2 className="text-5xl md:text-6xl font-serif text-ivory mb-8" data-id="element-132" data-mp="85fcf0g5xt2r">
            Join the Next Era of Wellness
          </h2>
          <p className="text-xl text-ivory/70 mb-12 font-light" data-id="element-133" data-mp="m3wzcvy8v1jm">
            Whether you are seeking care, providing care, or investing in the
            future of care — there is a place for you here.
          </p>
        </FadeIn>

        <FadeIn delay={200} className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6" data-id="element-134" data-mp="vwujt7msr0kv">
          <a href="/practitioners" data-id="element-135" data-mp="14uwrg611crh4">
            <Button variant="primary" size="lg" className="w-full sm:w-auto bg-purple-600 text-white hover:bg-purple-700" data-id="element-136" data-mp="14vzhycug4rwi">
              Join the Platform
            </Button>
          </a>
          <a href="/practitioners" data-id="element-137" data-mp="2h3ri8mmvdngt">
            <Button variant="outline" size="lg" className="w-full sm:w-auto border-ivory text-ivory hover:bg-ivory hover:text-charcoal" data-id="element-138" data-mp="2h4sq6i8l9tub">
              Apply to Network
            </Button>
          </a>
        </FadeIn>
      </div>
    </Section>;
}